<admin-uptime></admin-uptime>